import { type Theme } from '@mui/material';

export const scheduleAiOverrides = {
  visit: {
    created: {
      PRIMARY: 'statusDrafted.primary',
      SECONDARY: 'statusDrafted.secondary',
      BORDER: '#919EAB',
      BUFFER: 'statusDrafted.buffer',
      BORDER_WIDTH: 2,
      BORDER_STYLE: 'solid',
    },
    cancelled: {
      PRIMARY: 'statusCancelled.primary', // text
      SECONDARY: 'statusCancelled.secondary', // bg
      BORDER: 'transparent',
      BUFFER: 'statusCancelled.buffer',
      BORDER_WIDTH: 2,
      BORDER_STYLE: 'solid',
    },
    drafted: {
      PRIMARY: 'statusDrafted.primary',
      SECONDARY: 'statusDrafted.secondary',
      BORDER: '#919EAB',
      BUFFER: 'statusDrafted.buffer',
      BORDER_WIDTH: 2,
      BORDER_STYLE: 'solid',
    },
    allocated: {
      PRIMARY: 'statusAllocated.primary',
      SECONDARY: 'statusAllocated.secondary',
      BORDER: '#919EAB',
      BUFFER: 'statusAllocated.buffer',
      BORDER_WIDTH: 2,
      BORDER_STYLE: 'solid',
    },
    scheduled: {
      PRIMARY: 'statusScheduled.primary',
      SECONDARY: 'statusScheduled.secondary',
      BORDER: 'transparent',
      BUFFER: 'statusScheduled.buffer', // TBD
      BORDER_WIDTH: 2,
      BORDER_STYLE: 'solid',
    },
    accepted: {
      PRIMARY: 'statusAccepted.primary',
      SECONDARY: 'statusAccepted.secondary',
      BORDER: 'transparent',
      BUFFER: 'statusAccepted.buffer', // TBD
      BORDER_WIDTH: 1.5,
      BORDER_STYLE: 'dashed',
    },
    completed: {
      PRIMARY: 'statusCompleted.primary',
      SECONDARY: 'statusCompleted.secondary',
      BORDER: 'transparent',
      BUFFER: 'statusCompleted.buffer', // TBD
      BORDER_WIDTH: 2,
      BORDER_STYLE: 'solid',
    },
    requested: {
      PRIMARY: 'statusRequested.primary',
      SECONDARY: 'statusRequested.secondary',
      BORDER: 'transparent',
      BUFFER: 'statusRequested.buffer', // TBD
      BORDER_WIDTH: 2,
      BORDER_STYLE: 'solid',
    },
    pre_requested: {
      PRIMARY: 'statusPreRequested.primary',
      SECONDARY: 'statusPreRequested.secondary',
      BORDER: '#C684FF',
      BUFFER: 'statusPreRequested.buffer', // TBD
      BORDER_WIDTH: 2,
      BORDER_STYLE: 'solid',
    },
    pre_accepted: {
      PRIMARY: 'statusPreAccepted.primary',
      SECONDARY: 'statusPreAccepted.secondary',
      BORDER: '#77ED8B',
      BUFFER: 'statusPreAccepted.buffer', // TBD
      BORDER_WIDTH: 2,
      BORDER_STYLE: 'solid',
    },
    pre_scheduled: {
      PRIMARY: 'statusPreScheduled.primary',
      SECONDARY: 'statusPreScheduled.secondary',
      BORDER: '#61F3F3',
      BUFFER: 'statusPreScheduled.buffer', // TBD
      BORDER_WIDTH: 2,
      BORDER_STYLE: 'solid',
    },
    rejected: {
      PRIMARY: 'statusRejected.primary',
      SECONDARY: 'statusRejected.secondary',
      BORDER: '#FFAC82',
      BUFFER: 'statusRejected.buffer', // TBD
      BORDER_WIDTH: 2,
      BORDER_STYLE: 'solid',
    },
  },
  /** Mobiscroll calendar tints for national holidays / time off (see `getCalendarUnavailabilityMobiscrollColors`). */
  calendarUnavailability: {
    /** Palette path to an RGB channel string (e.g. grey.500Channel) for use with `varAlpha`. */
    tintChannel: 'grey.500Channel',
    tintOpacity: 0.2,
    /** Palette path for label text on tinted cells (e.g. text.secondary). */
    textColor: 'text.secondary',
  },
  /** Outlook / external calendar blockers on the schedule timeline and monthly calendar. */
  externalCalendarEvent: {
    backgroundChannel: 'grey.500Channel',
    backgroundOpacity: 0.16,
    badgeChannel: 'grey.500Channel',
    badgeOpacity: 0.32,
    textColor: 'text.secondary',
    iconColor: 'text.disabled',
  },
  userIcon: {
    internal: {
      bgColor: 'grey.200',
      borderColor: 'grey.500',
      borderStyle: 'solid',
      textColor: 'text.secondary',
    },
    external: {
      bgColor: 'grey.200',
      borderColor: 'grey.500',
      borderStyle: 'dashed',
      textColor: 'text.secondary',
    },
  },
  priority: {
    URGENT: {
      iconColor: '#FF5630',
    },
    NORMAL: {
      iconColor: '#1D7BF5',
    },
    HIGH: {
      iconColor: '#FFAB00',
    },
    LOW: {
      iconColor: '#919EAB',
    },
  },
};

export type ScheduleAiTheme = Theme & typeof scheduleAiOverrides;
